import { backendSessionsQueryOptions } from '@/src/queries/session-queries'
import { useQuery } from '@tanstack/react-query'

import {
  findPendingSessionId,
  isSessionReminderDue,
} from '../utils/session-reminder'

export function useSessionReminderBanner({
  enabled = true,
  sessionDefinitionId,
}: {
  enabled?: boolean
  sessionDefinitionId: number
}) {
  const { data: sessions } = useQuery({
    ...backendSessionsQueryOptions,
    enabled,
  })

  if (!enabled) {
    return { shouldShow: false }
  }
  if (sessions == null) {
    return { shouldShow: false }
  }

  const pendingSessionId = findPendingSessionId({
    sessions,
    definitionId: sessionDefinitionId,
  })

  return {
    shouldShow:
      pendingSessionId != null ||
      isSessionReminderDue({
        sessions,
        definitionId: sessionDefinitionId,
      }),
  }
}
